"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=require("./getEnvironmentFromHostname.cjs");function t(){return n.getEnvironmentFromHostname()==="staging"}exports.isStagingEnvironment=t;
//# sourceMappingURL=isStagingEnvironment.cjs.map
